<div class="column">
  @for (policy of cardPolicies(); track policy.policyMasterID; let i = $index) {
    <ez-policy-card [policy]="policy"
                    [selected]="policySelectionStates()[i]"
                    [radioMode]="!isSelectionDisabled()"
                    [attr.inert]="hasSelection() && !policySelectionStates()[i] || null"
                    (selectedChange)="onPolicySelect(policy.policyMasterID, $event)" />
  }
</div>
